import { render, staticRenderFns } from "./ManageOrdersPage.vue?vue&type=template&id=6ffaffca&scoped=true&"
import script from "./ManageOrdersPage.vue?vue&type=script&lang=js&"
export * from "./ManageOrdersPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrdersPage.vue?vue&type=style&index=0&id=6ffaffca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffaffca",
  null
  
)

export default component.exports